/*
 * Base Google Map example
 */
import React, { Component } from 'react';

import GoogleMapReact from 'google-map-react';
import './MultiMarkerMap.css'


class MultiMarkerMap extends Component {

    constructor(props) {
        super(props);
        this.renderMarkers = this.renderMarkers.bind(this)
        this.plotMarkers = this.plotMarkers.bind(this)
    }
    
    setMapRef(map, maps) {
        this.googleMap = map
        this.googleMaps = maps
        this.markers = []
    }
    plotMarkers() {
        const { customers } = this.props
        const mapCenter = customers.length > 0 ? {lat: Number(customers[0].lat), lng: Number(customers[0].lng)} : {lat: 0, lng: 0}
        this.googleMap.setCenter(mapCenter)
        this.renderMarkers(this.googleMap, this.googleMaps, customers)
    }
    renderMarkers = (map, maps, customers) => {
        for (let m of this.markers) {
            m.setMap(null);
          }
        this.markers = []
        for (let i = 0; i<customers.length; i++){
            let customer = customers[i]
            let marker = new maps.Marker({
                position: {lat: Number(customer.lat), lng: Number(customer.lng)},
                map,
                title: customer['name']
            });
            marker.addListener("click", () => {
                window.open(`http://maps.google.co.th/maps?q=${customer.lat},${customer.lng}`, '_blank').focus();
            });
            this.markers.push(marker)
        }
    };

    componentDidMount() {
        this.props.onRef(this);
    }

    render() {
        const { customers } = this.props
        const mapCenter = customers.length > 0 ? {lat: Number(customers[0].lat), lng: Number(customers[0].lng)} : {lat: 0, lng: 0}        
        return (
            <div style={{ aspectRatio: 1, width: '100%' }}>
                <div style={{ height: '100%', width: '100%' }}>
                    <GoogleMapReact
                        apiKey={"AIzaSyAdbJX-7pT5ANftYb4rpQc3Md3xIclasos"} // set if you need stats etc ...
                        center={mapCenter}
                        defaultZoom={12}
                        onGoogleApiLoaded={({ map, maps }) => this.setMapRef(map, maps)}
                    >                        
                    </GoogleMapReact>

                </div>
            </div>
        );
    }
}

export default MultiMarkerMap;